<template>
  <div>
    <van-cell  >
      <van-image slot="icon" round
                 width="25"
                 height="25"
                 :src="headimgurl"
      />
      <span slot="title" style="display:inline-block;color:#8197b3;font-size: 14px;height: 25px;line-height: 25px;margin-left: 5px">{{nickname}}</span>

      <span slot="right-icon" style="color:#8197b3;font-size: 12px ">{{text}}</span>
    </van-cell>
  </div>
</template>

<script>
export default {
  props: ["uid","text"],
  data:function(){
    return {
      nickname:'',
      headimgurl:'https://img.yzcdn.cn/vant/cat.jpeg'
    }
  },
  watch:{
    uid:function(newVal,oldVal){
      if(oldVal=='' && newVal){
        this.getInfo();
      }
    }
  },
  methods:{
    getInfo:function(){
      var app = this;
      console.log("getInfo",app.uid);

      app.axios.post("/userCache",{
        uid:app.uid,
      })
              .then(function(res){

                if(res.data.errcode=="suc"){
                  app.nickname = res.data.data.nickname;
                  app.headimgurl = res.data.data.headimgurl;
                }
                else{
                  app.nickname = app.uid;
                }
              })
              .catch(function(){
                app.nickname = app.uid
              })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  .van-uploader__upload-text{
    color:#43b292;
    font-size: 12px;
  }
  .van-uploader__upload-icon{
    color:#43b292;
  }
  .van-icon-plus:before{
    font: 14px/1 "FontAwesome";
    font-size: 18px;
    content: "\f0fe"
  }
</style>
